import carQuestionSets from '../Config/externalSelectConfig';

const isSelectComponent = (component) =>
  (component?.input?.type || component?.component?.type) === 'select';

const getSelectMappedQuestionIds = (components) =>
  Object.values(components)
    .filter(isSelectComponent)
    .map((component) => component?.component?.mappedQuestionId);

/**
 * Resolves the Car API question set (if any) that a question belongs to.
 *
 * @returns {object|null} the mapped-question-id keyed dependency map for the
 * set containing mappedQuestionId, provided all of its questions are present
 * as selects in the form, or null
 */
const getExternalSelectDependencies = (components, mappedQuestionId) => {
  if (!mappedQuestionId) return null;

  const selectMappedQuestionIds = getSelectMappedQuestionIds(components);

  return (
    carQuestionSets.find(
      (questionSet) =>
        mappedQuestionId in questionSet &&
        Object.keys(questionSet).every((questionId) =>
          selectMappedQuestionIds.includes(questionId)
        )
    ) || null
  );
};

export default getExternalSelectDependencies;
